export default [
    {name: 'Basic', description: 'A basic account allows you to edit basic profile data.', price: 0, priceInfo: 'Free'},
    {name: 'Premium', description: 'A premium account includes basic account benefits plus the ability to create a robustly branded profile and post content to the career feed.', price: 0, priceInfo: 'Free for a limited time'}
];
